import type {
  IToolbarItemConfigTiptap,
  IToolbarSettings,
  PublisherProvider,
  ToolbarButtonRenderers,
} from './../../../ricos-types';
import { TOOLBARS } from './../../../editor-common';

import type { Topics } from '../../topics';
import type { ToolbarServices } from '../../types';
import { RicosToolbar } from '../ricos-toolbar';

export class PluginToolbar extends RicosToolbar<TOOLBARS.PLUGIN> {
  constructor(
    isMobile: boolean,
    services: ToolbarServices,
    publishers: PublisherProvider<Topics>,
    settings: IToolbarSettings<TOOLBARS.PLUGIN>,
    shouldCreate: boolean
  ) {
    super(isMobile, services, TOOLBARS.PLUGIN, publishers, settings);
    this.isEmpty = () => !shouldCreate;
  }

  isVisible = (): boolean => {
    return !!this.services.plugins?.getVisibleToolbar(
      this.services.editor.adapter.tiptapEditor.state.selection,
      this.services.editor
    );
  };

  getToolbarItemsConfig(): IToolbarItemConfigTiptap[] {
    const visibleToolbar = this.services.plugins?.getVisibleToolbar(
      this.services.editor.adapter.tiptapEditor.state.selection,
      this.services.editor
    );

    if (!visibleToolbar) {
      return [];
    }

    return visibleToolbar.toToolbarItemsConfig();
  }

  getMegaToolbarItemsConfig(): IToolbarItemConfigTiptap[] {
    const visibleToolbar = this.services.plugins?.getVisibleToolbar(
      this.services.editor.adapter.tiptapEditor.state.selection,
      this.services.editor
    );

    if (!visibleToolbar) {
      return [];
    }

    const { pluginType } = visibleToolbar;
    // TODO: refactor this
    const isTable = pluginType === 'TABLE';
    const config = visibleToolbar.toToolbarItemsConfig();

    return isTable ? config.slice(2, -1) : config;
  }

  getToolbarItemsRenderers(
    _referenceElement?: HTMLElement | null | undefined
  ): ToolbarButtonRenderers {
    const visibleToolbar = this.services.plugins?.getVisibleToolbar(
      this.services.editor.adapter.tiptapEditor.state.selection,
      this.services.editor
    );

    if (!visibleToolbar) {
      return {};
    }

    return visibleToolbar.getToolbarButtonsRenderers();
  }
}
